import { Directive, ElementRef } from '@angular/core';
declare var $: any;

@Directive({
  selector: '.effect-8, .effect-11, .effect-17, .effect-19, .effect-20, .effect-22, .effect-24',
  exportAs: 'inputEffect'
})

export class InputEffectDirective {

  private el: HTMLInputElement;

  constructor(
        private elementRef: ElementRef,
    ) {
        this.el = this.elementRef.nativeElement;
    }

  checkValue() {

    const $element = $(this.el);
    let placeHolder = $element.attr('placeholder');
    if ($element.val() !== '' || placeHolder !== '') {
      $element.addClass('has-content');
    } else {
      $element.removeClass('has-content');
    }
  }


  ngOnInit() {
    this.checkValue();

    const $element = $(this.el);
    $element.change(function(){
      
      let placeHolder = $(this).attr('placeholder');
      if ($(this).val() !== '' || placeHolder !== '') {
        $(this).addClass('has-content');
      } else {
        $(this).removeClass('has-content');
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/app/directives/input-effect.ts